<script setup lang="ts">
import type { ButtonAlignment } from '~/enums/button-alignment'
import type { Image, Button } from '~/types'

interface Props {
  anchor?: string
  image?: Image
  buttonsAlignment?: ButtonAlignment.LEFT
  buttons?: Button[]
}

defineProps<Props>()
</script>

<template>
  <section
    v-if="image"
    :id="anchor"
    class="banner"
  >
    <img
      :src="image.src"
      :alt="image.alt"
      class="banner__image"
    >
    <div
      v-if="buttons"
      class="banner__buttons"
    >
      <div class="wrapper">
        <CommonButtons
          :alignment="buttonsAlignment"
          :buttons="buttons"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.banner {
  @apply mb-[40px] relative;
  @apply md:mb-[60px];
  @apply lg:mb-[90px];

  &__image {
    @apply w-full h-auto block;
  }

  &__buttons {
    @apply left-1/2 top-1/2 mt-[20px];
    @apply md:absolute md:-translate-x-1/2 md:-translate-y-1/2 md:mt-0;
  }
}
</style>
